<button (click)="dismiss()" type="button" class="mui-modal__close" aria-label="Close">
  <i mui-icon font="fa" name="times"></i>
</button>
<div class="mui-modal__header">
  <h3 class="mui-modal__title">
    {{ 'dashboardPage.widgetConfigDialog.title' | translate: { widgetName: widgetName | translate } }}
  </h3>
</div>
<div *ngIf="content">
  <ng-container [ngTemplateOutlet]="content"></ng-container>
</div>
